import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Alert from 'react-s-alert';
import { withRouter } from 'react-router-dom';

import Posts from 'api/resources/posts';
import { processErrorByAlert } from 'utils/getErrors';

import Main from 'styled/Page/Main';
import PublicationForm from 'admin-editor/components/PublicationForm';

export class PublicationCreatePage extends React.PureComponent {
  state = {
    loading: false,
  }

  handleClose = () => {
    if (!this.props.location.key) {
      this.props.history.push('/publications');
      return;
    }

    this.props.history.goBack();
  }

  handleSave = async ({ data, exit }) => {
    this.setState({
      loading: true,
    });

    try {
      const response = await Posts.create({ body: { data } });

      this.setState({ loading: false });
      Alert.success('Публикация успешно создана');

      // Нужен для правильной навигации.
      // Для редиректа из новой попубликации в общий список публикаций по закрытию
      // Иначе редирект произойдет на /publications/new
      const PUBLICATIONS_ROUTE_WITH_HASH = response.data ? `/publications/${response.data.id}#new` : '/publications';

      const redirectRoute = exit ? '/publications' : PUBLICATIONS_ROUTE_WITH_HASH;

      this.props.history.push(redirectRoute);
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <Main>
        <Helmet>
          <title>Создание публикации</title>
        </Helmet>

        <PublicationForm
          onSave={this.handleSave}
          onClose={this.handleClose}
          loading={this.state.loading}
        />
      </Main>
    );
  }
}

PublicationCreatePage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    goBack: PropTypes.func,
  }),
  location: PropTypes.shape({
    key: PropTypes.string,
  }),
};

PublicationCreatePage.defaultProps = {
  history: {
    push: () => {},
    goBack: () => {},
  },
  location: {},
};

export default withRouter(PublicationCreatePage);
